<template>
  <div
    v-if="data"
    class="item"
    @click="clickDetail(data)"
  >
    <div class="top">
      <!-- code -->
      <span class="code"><i class="iconfont iconicon-test30 fs-gray" />{{ data.code.code }}</span>
      <!-- 状态 -->
      <div
        v-if="status && status.value"
        class="right"
      >
        <span
          :style="{ 'background-color': status.color }"
          class="status"
        >{{ status.value }}</span>
      </div>
    </div>
    <!-- 其他字段处理后的列表 -->
    <ul>
      <template v-for="item in data.list">
        <li
          :key="item.fieldkey"
          class="one"
        >
          <span class="label">{{ item.title }}：</span>
          <span v-if="item.fieldkey === 'contact_info'">{{ item.contact_name.fieldvalue || '- -' }}</span>
          <span v-else>{{ item.fieldvalue || '- -' }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    'data': {
      type: Object,
      default: () => { }
    },
    typeParam: {
      type: [String, Number],
      default: ''
    }
  },
  computed: {
    status () {
      if (!this.data) return
      let data = {}
      data.value = this.typeParam === -1 ? this.$t('message["542"]') : this.typeParam === 0 ? this.$t('message["143"]') : this.typeParam === 1 ? this.$t('message["1206"]') : ''

      switch (data.value) {
        case this.$t('message["1206"]'):
          data.color = '#42C27E'
          break
        case this.$t('message["143"]'):
          data.color = '#F6A953'
          break
        case this.$t('message["542"]'):
          data.color = '#F57676'
          break
      }

      return data
    }
  },
  methods: {
    clickDetail (data) {
      this.$emit('handleDetail', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: 350px;
  margin: 12px;
  padding: 8px 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(229, 229, 229, 1);
  .top {
    display: flex;
    justify-content: space-between;
    /* height: 38px;
    line-height: 38px; */
    padding: 12px;
  }
  .code {
    align-self: center;
    font-size: 14px;
    .iconfont {
      margin-right: 4px;
      font-size: 16px;
      color: #d6d6d6;
    }
  }
  .level::v-deep {
    // margin-left: 8px;
    .cube-rate {
      // width: 120px;
      vertical-align: middle;
    }
    .cube-rate-item {
      width: 14px;
      margin-right: 2px;
    }
  }
  .status {
    display: inline-block;
    height: 18px;
    line-height: 18px;
    // margin-right: 23px;
    padding: 0 8px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    background-color: $danger-color;
  }
  .one {
    line-height: 24px;
    padding: 8px 12px;
    font-size: 14px;
    .label {
      display: inline-block;
      /* width: 80px;
      text-align: right; */
    }
    i {
      font-style: normal;
    }
  }
}
</style>
